import * as React from 'react';
import { Translate } from '../../shared/LanguageService';
import IPlanTemplate from './IPlanTemplate';
import { Table } from 'react-bootstrap';
import PlanTemplateListRow from './PlanTemplateListRow';

interface IPlanTemplateListProps {
    items: IPlanTemplate[];
    delete: (id: number) => void;
    edit: (planTemplate: IPlanTemplate) => void;
}

const PlanTemplateList = (props: IPlanTemplateListProps) => {
    return (
        <Table hover responsive>
            <thead>
                <tr>
                    <th>{Translate('plan-templates/list/table-header/name')}</th>
                </tr>
            </thead>
            <tbody>
                {props.items.map((item: IPlanTemplate) => {
                    return (
                        <PlanTemplateListRow
                            planTemplate={item}
                            delete={props.delete}
                            edit={props.edit}
                            key={item.id}
                        />
                    );
                })}
            </tbody>
        </Table>
    );
};

export default PlanTemplateList;
